import type { DebugControls } from "./view-model";

export interface DebugToolbarProps {
  debug: DebugControls;
}

const HOUR_MS = 3_600_000;

const STEPS: ReadonlyArray<{ label: string; ms: number; testId: string }> = [
  { label: "+1 h", ms: 1 * HOUR_MS, testId: "debug-plus-1h" },
  { label: "+8 h", ms: 8 * HOUR_MS, testId: "debug-plus-8h" },
  { label: "+24 h", ms: 24 * HOUR_MS, testId: "debug-plus-24h" },
  { label: "+7 d", ms: 7 * 24 * HOUR_MS, testId: "debug-plus-7d" },
];

export function DebugToolbar({ debug }: DebugToolbarProps) {
  return (
    <aside
      className="panel debug-toolbar"
      aria-label="Debug time controls"
      data-testid="debug-toolbar"
    >
      <div className="demo">
        <span data-testid="debug-now">{debug.nowLabel}</span>
        {STEPS.map((step) => (
          <button
            key={step.label}
            type="button"
            data-testid={step.testId}
            onClick={() => debug.advance(step.ms)}
          >
            {step.label}
          </button>
        ))}
        <button
          type="button"
          data-testid="debug-reset"
          onClick={() => debug.reset()}
        >
          Reset game
        </button>
      </div>
    </aside>
  );
}
